import type { NetworkSummary, Vps } from "./types";

function normalize(value: string): string {
  return value.trim().toLocaleLowerCase("cs-CZ");
}

export function matchesVpsSearch(vps: Vps, network: NetworkSummary | undefined, search: string): boolean {
  const needle = normalize(search);
  if (!needle) return true;

  const networkValues = network
    ? [...network.publicAddresses, ...network.privateAddresses].flatMap((address) => [
        address.mac,
        address.ipv4,
        address.ipv6LinkLocal,
        address.ipv6Global,
        address.ipv4Ptr,
        address.ipv6Ptr,
      ])
    : [];

  return [vps.name, vps.id, vps.template, ...networkValues]
    .filter((value): value is string => Boolean(value))
    .some((value) => normalize(value).includes(needle));
}
